import { attachAuth } from '@if/mui'
import axios from 'axios'
import { APP_VERSION } from '@src/appVersion'
import { reportErrorToServer } from '@src/services/error-logger'

function resolveApiUrl() {
  if (import.meta.env.PROD) return `${window.location.origin}/api`
  return import.meta.env.VITE_API_URL
}

function createInstance() {
  const client = axios.create({
    baseURL: resolveApiUrl(),
    headers: {
      'X-requestor': `MerchantsDashboardApp:${APP_VERSION}`,
    },
  })

  // Bearer injection + single-flight 401 re-exchange, owned by @if/mui's auth
  // pipeline (token stored/renewed by AuthProvider; this reads it per request).
  attachAuth(client)

  // API-error telemetry to AppInsights (network noise is filtered inside
  // reportErrorToServer). Registered after attachAuth so a 401 that is
  // transparently retried and succeeds is never reported.
  client.interceptors.response.use(
    (response) => response,
    (error: unknown) => {
      reportErrorToServer(error instanceof Error ? error : String(error))
      throw error
    },
  )

  return client
}

const instance = createInstance()

export function getApiClient() {
  return instance
}
